// AgentOnboardingPage.jsx

import React, { useState } from 'react';
import { Box, Typography, TextField, Button, Checkbox, FormControlLabel, Paper, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useOnboarding } from '../../../hooks/useAgentOnboarding';
import { useAuth } from '../../../hooks/useAuth';
import AgentOnboardingStyles from './AgentOnboardingPage.styles';

const AgentOnboardingPage = () => {
  const [formData, setFormData] = useState({
    businessName: '',
    taxId: '',
    address: '',
    city: '',
    state: '',
    zip: '',
  });
  const [disclosureAccepted, setDisclosureAccepted] = useState(false);
  const [photoId, setPhotoId] = useState(null);
  const { currentUser, ROLES } = useAuth();
  const isManager = currentUser?.userType === ROLES.MANAGER;
  const { loading, error, submitOnboarding } = useOnboarding();
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setPhotoId(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.businessName || !formData.taxId || !formData.address || !formData.city || !formData.state || !formData.zip || !photoId || !disclosureAccepted) {
      alert('Please fill out all fields, upload the required files, and accept the disclosures.');
      return;
    }

    try {
      // Submit onboarding data to Firebase
      await submitOnboarding(currentUser.uid, formData, photoId);

      // Navigate to dashboard on success
      navigate('/agent-dashboard');
    } catch (err) {
      console.error('Error during onboarding:', {
        message: err.message,
        response: err.response ? err.response.data : 'No response data',
      });
      alert(`Failed to complete onboarding: ${err.message}`);
    }
  };

  return (
    <Box sx={AgentOnboardingStyles.rootBox}>
        <Typography variant="h4" sx={{ mb: 2 }}>
    {isManager ? 'Manager Onboarding' : 'Agent Onboarding'}
  </Typography>
      <Paper sx={AgentOnboardingStyles.paper} elevation={6}>
        <Typography
          variant="h4"
          component="h1"
          sx={AgentOnboardingStyles.header}
        >
          Property Manager/Property Owner Onboarding
        </Typography>

        <form onSubmit={handleSubmit}>
          <TextField
            label="Business Name"
            name="businessName"
            variant="outlined"
            fullWidth
            required
            value={formData.businessName}
            onChange={handleInputChange}
            sx={AgentOnboardingStyles.textField}
          />

          <TextField
            label="Tax ID"
            name="taxId"
            variant="outlined"
            fullWidth
            required
            value={formData.taxId}
            onChange={handleInputChange}
            sx={AgentOnboardingStyles.textField}
          />

          <TextField
            label="Street Address"
            name="address"
            variant="outlined"
            fullWidth
            required
            value={formData.address}
            onChange={handleInputChange}
            sx={AgentOnboardingStyles.textField}
          />

          <TextField
            label="City"
            name="city"
            variant="outlined"
            fullWidth
            required
            value={formData.city}
            onChange={handleInputChange}
            sx={AgentOnboardingStyles.textField}
          />

          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                label="State"
                name="state"
                variant="outlined"
                fullWidth
                required
                value={formData.state}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="ZIP Code"
                name="zip"
                variant="outlined"
                fullWidth
                required
                value={formData.zip}
                onChange={handleInputChange}
              />
            </Grid>
          </Grid>

          <Typography variant="body1" sx={AgentOnboardingStyles.disclosureText}>
            By proceeding, you acknowledge that you have read and accept the
            terms and conditions outlined below.
          </Typography>

          <Paper elevation={3} sx={AgentOnboardingStyles.disclosurePaper}>
            <Typography variant="body2">
              New landlord user onboarding needs disclosure revision at
              placeholder and a description of the business documents to upload
              to verify. Please add the following description for Business ID
              Documents at new user registration for landlord/property
              management users: Property Management Company Users: Please upload
              a copy of your company real estate license. OR Self-Managing
              Property Owners: Please upload proof of ownership from county
              records with a matching identification that will be required for
              review. *To protect property owners and tenants, we verify proof
              of legal purpose and/or representation for each property before we
              allow automated showings or access to properties through our
              platform. Disclosure verbiage will change to a link to review
              Terms and Conditions. Terms and Conditions are also attached to
              link to somewhere on the site and the the users will check a box
              saying they agree to terms. (See second attachment for Terms and
              Conditions)
            </Typography>
          </Paper>

          <FormControlLabel
            control={
              <Checkbox
                checked={disclosureAccepted}
                onChange={(e) => setDisclosureAccepted(e.target.checked)}
                color="primary"
                required
              />
            }
            label="I accept the terms and conditions"
          />

          <Box sx={AgentOnboardingStyles.fileUploadButton}>
            <Button variant="contained" component="label">
              Upload Business ID or Document
              <input
                type="file"
                hidden
                accept=".jpg,.png,.pdf"
                onChange={handleFileChange}
              />
            </Button>
            {photoId && (
              <Typography variant="body2">
                Uploaded file: {photoId.name}
              </Typography>
            )}
          </Box>

          {error && (
            <Typography color="error" sx={AgentOnboardingStyles.errorText}>
              {error}
            </Typography>
          )}

          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={AgentOnboardingStyles.submitButton}
            disabled={loading}
          >
            {loading ? "Submitting..." : "Complete Onboarding"}
          </Button>
        </form>
      </Paper>
    </Box>
  );
};

export default AgentOnboardingPage;


// import React, { useState } from 'react';
// import { Box, Typography, TextField, Button, Checkbox, FormControlLabel, Paper, Grid } from '@mui/material';
// import { useNavigate } from 'react-router-dom';
// import { useOnboarding } from '../../../hooks/useAgentOnboarding';
// import { useAuth } from '../../../hooks/useAuth';
// import AgentOnboardingStyles from './AgentOnboardingPage.styles';
// import axios from 'axios';

// const AgentOnboardingPage = () => {
//   const [formData, setFormData] = useState({
//     businessName: '',
//     taxId: '',
//     address: '',
//     city: '',
//     state: '',
//     zip: '',
//   });
//   const [disclosureAccepted, setDisclosureAccepted] = useState(false);
//   const [photoId, setPhotoId] = useState(null);
//   const { currentUser, ROLES } = useAuth();
//   const isManager = currentUser?.userType === ROLES.MANAGER;
//   const { loading, error, submitOnboarding } = useOnboarding();
//   const navigate = useNavigate();

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//   };

//   const handleFileChange = (e) => {
//     setPhotoId(e.target.files[0]);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!formData.businessName || !formData.taxId || !formData.address || !formData.city || !formData.state || !formData.zip || !photoId || !disclosureAccepted) {
//       alert('Please fill out all fields, upload the required files, and accept the disclosures.');
//       return;
//     }

//     try {
//       // Submit onboarding data to Firebase
//       await submitOnboarding(currentUser.uid, formData, photoId);

//       // Send the photoId document via email
//       if (photoId) {
//         const formDataToSend = new FormData();
//         formDataToSend.append('files', photoId); // Changed from 'file' to 'files'
//         formDataToSend.append('to', 'info@tenantguidedtours.com');
//         formDataToSend.append('subject', 'New Agent Onboarding Document');
//         formDataToSend.append('text', 'Here’s the uploaded onboarding document.');

//         console.log('Sending email with document:', {
//           filename: photoId.name,
//           size: photoId.size,
//           type: photoId.type,
//         });

//         const response = await axios.post('https://ai-realtor.onrender.com/send-email', formDataToSend, {
//           headers: { 'Content-Type': 'multipart/form-data' },
//         });
//         console.log('Email API response:', response.data);
//       }

//       navigate('/agent-dashboard');
//     } catch (err) {
//       console.error('Error during onboarding or email sending:', {
//         message: err.message,
//         response: err.response ? err.response.data : 'No response data',
//       });
//       alert(`Failed to complete onboarding or send email: ${err.message}`);
//     }
//   };

//   return (
//     <Box sx={AgentOnboardingStyles.rootBox}>
//         <Typography variant="h4" sx={{ mb: 2 }}>
//     {isManager ? 'Manager Onboarding' : 'Agent Onboarding'}
//   </Typography>
//       <Paper sx={AgentOnboardingStyles.paper} elevation={6}>
//         <Typography
//           variant="h4"
//           component="h1"
//           sx={AgentOnboardingStyles.header}
//         >
//           Property Manager/Property Owner Onboarding
//         </Typography>

//         <form onSubmit={handleSubmit}>
//           <TextField
//             label="Business Name"
//             name="businessName"
//             variant="outlined"
//             fullWidth
//             required
//             value={formData.businessName}
//             onChange={handleInputChange}
//             sx={AgentOnboardingStyles.textField}
//           />

//           <TextField
//             label="Tax ID"
//             name="taxId"
//             variant="outlined"
//             fullWidth
//             required
//             value={formData.taxId}
//             onChange={handleInputChange}
//             sx={AgentOnboardingStyles.textField}
//           />

//           <TextField
//             label="Street Address"
//             name="address"
//             variant="outlined"
//             fullWidth
//             required
//             value={formData.address}
//             onChange={handleInputChange}
//             sx={AgentOnboardingStyles.textField}
//           />

//           <TextField
//             label="City"
//             name="city"
//             variant="outlined"
//             fullWidth
//             required
//             value={formData.city}
//             onChange={handleInputChange}
//             sx={AgentOnboardingStyles.textField}
//           />

//           <Grid container spacing={2}>
//             <Grid item xs={6}>
//               <TextField
//                 label="State"
//                 name="state"
//                 variant="outlined"
//                 fullWidth
//                 required
//                 value={formData.state}
//                 onChange={handleInputChange}
//               />
//             </Grid>
//             <Grid item xs={6}>
//               <TextField
//                 label="ZIP Code"
//                 name="zip"
//                 variant="outlined"
//                 fullWidth
//                 required
//                 value={formData.zip}
//                 onChange={handleInputChange}
//               />
//             </Grid>
//           </Grid>

//           <Typography variant="body1" sx={AgentOnboardingStyles.disclosureText}>
//             By proceeding, you acknowledge that you have read and accept the
//             terms and conditions outlined below.
//           </Typography>

//           <Paper elevation={3} sx={AgentOnboardingStyles.disclosurePaper}>
//             <Typography variant="body2">
//               New landlord user onboarding needs disclosure revision at
//               placeholder and a description of the business documents to upload
//               to verify. Please add the following description for Business ID
//               Documents at new user registration for landlord/property
//               management users: Property Management Company Users: Please upload
//               a copy of your company real estate license. OR Self-Managing
//               Property Owners: Please upload proof of ownership from county
//               records with a matching identification that will be required for
//               review. *To protect property owners and tenants, we verify proof
//               of legal purpose and/or representation for each property before we
//               allow automated showings or access to properties through our
//               platform. Disclosure verbiage will change to a link to review
//               Terms and Conditions. Terms and Conditions are also attached to
//               link to somewhere on the site and the the users will check a box
//               saying they agree to terms. (See second attachment for Terms and
//               Conditions)
//             </Typography>
//           </Paper>

//           <FormControlLabel
//             control={
//               <Checkbox
//                 checked={disclosureAccepted}
//                 onChange={(e) => setDisclosureAccepted(e.target.checked)}
//                 color="primary"
//                 required
//               />
//             }
//             label="I accept the terms and conditions"
//           />

//           <Box sx={AgentOnboardingStyles.fileUploadButton}>
//             <Button variant="contained" component="label">
//               Upload Business ID or Document
//               <input
//                 type="file"
//                 hidden
//                 accept=".jpg,.png,.pdf"
//                 onChange={handleFileChange}
//               />
//             </Button>
//             {photoId && (
//               <Typography variant="body2">
//                 Uploaded file: {photoId.name}
//               </Typography>
//             )}
//           </Box>

//           {error && (
//             <Typography color="error" sx={AgentOnboardingStyles.errorText}>
//               {error}
//             </Typography>
//           )}

//           <Button
//             type="submit"
//             variant="contained"
//             color="primary"
//             fullWidth
//             sx={AgentOnboardingStyles.submitButton}
//             disabled={loading}
//           >
//             {loading ? "Submitting..." : "Complete Onboarding"}
//           </Button>
//         </form>
//       </Paper>
//     </Box>
//   );
// };

// export default AgentOnboardingPage;